// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class Level1CalculatorUtils {
    static getColorByDifference(prev, curr) {
        if (isNaN(prev) || isNaN(curr)) {
            return ColoringEnum.Neitral;
        }
        if (curr > prev) {
            return ColoringEnum.Positive;
        }
        else if (curr < prev) {
            return ColoringEnum.Negative;
        }
        return ColoringEnum.Previous;
    }
    static getColorBySign(curr) {
        if (isNaN(curr)) {
            return ColoringEnum.Neitral;
        }
        if (curr > 0) {
            return ColoringEnum.Positive;
        }
        else if (curr < 0) {
            return ColoringEnum.Negative;
        }
        return ColoringEnum.Neitral;
    }
    static getChangeDirectionArrow(oldChange, newChange) {
        if (isNullOrUndefined(newChange) || isNaN(newChange)) {
            return DirectionArrowEnum.Unknown;
        }
        if (isNullOrUndefined(oldChange) || isNaN(oldChange)) {
            const coloring = this.getColorBySign(newChange);
            if (coloring === ColoringEnum.Positive) {
                return DirectionArrowEnum.Up;
            }
            else if (coloring === ColoringEnum.Negative) {
                return DirectionArrowEnum.Down;
            }
        }
        if (newChange > oldChange) {
            return DirectionArrowEnum.Up;
        }
        else if (newChange < oldChange) {
            return DirectionArrowEnum.Down;
        }
    }
}
export var ColoringEnum;
(function (ColoringEnum) {
    ColoringEnum[ColoringEnum["Neitral"] = 0] = "Neitral";
    ColoringEnum[ColoringEnum["Positive"] = 1] = "Positive";
    ColoringEnum[ColoringEnum["Negative"] = 2] = "Negative";
    ColoringEnum[ColoringEnum["Previous"] = 3] = "Previous";
})(ColoringEnum || (ColoringEnum = {}));
export var DirectionArrowEnum;
(function (DirectionArrowEnum) {
    DirectionArrowEnum[DirectionArrowEnum["Up"] = 0] = "Up";
    DirectionArrowEnum[DirectionArrowEnum["Down"] = 1] = "Down";
    DirectionArrowEnum[DirectionArrowEnum["Unknown"] = 2] = "Unknown";
})(DirectionArrowEnum || (DirectionArrowEnum = {}));
